import { useState, useCallback } from "react";
import toast from "react-hot-toast";
import client from "../api/client";
import { showApiError } from "../utils";

const useHouseholdMoved = (setDataList) => {
  const [movedTarget, setMovedTarget] = useState(null);

  const setHouseholdMovedFlag = useCallback(
    (householdId, value) => {
      setDataList((prev) =>
        prev.map((row) =>
          row.id === householdId
            ? { ...row, properties: { ...row.properties, household_moved: value } }
            : row,
        ),
      );
    },
    [setDataList],
  );

  const handleMoved = useCallback(
    (householdId, newHousehold) => {
      setHouseholdMovedFlag(householdId, "true");
      if (newHousehold?.id) {
        setDataList((prev) =>
          prev.some((row) => row.id === newHousehold.id) ? prev : [...prev, newHousehold],
        );
      }
    },
    [setHouseholdMovedFlag, setDataList],
  );

  const handleUndoMoved = useCallback(
    async (household) => {
      try {
        await client.post("/household/undo-moved", { householdId: household.id });
        setHouseholdMovedFlag(household.id, "false");
        toast.success("Moved status removed");
      } catch (error) {
        showApiError(error, "Could not undo Moved status");
      }
    },
    [setHouseholdMovedFlag],
  );

  return {
    movedTarget,
    openMoved: setMovedTarget,
    closeMoved: () => setMovedTarget(null),
    handleMoved,
    handleUndoMoved,
  };
};

export default useHouseholdMoved;
